import React from "react";
import { Link } from "gatsby";

import Layout from "../components/layout";
import SEO from "../components/seo";

import donald from "../images/team/Donald.jpg";
import rebecca from "../images/team/RebeccaDickerson.png";
import marjie from "../images/team/MarjieBohning.png"; 
import goforth from "../images/team/JonathanGoforth.jpeg";
import jamie from "../images/team/JamieAlaniz.jpeg";
import natalie from "../images/team/NataliePool.jpeg";
import jennifer from "../images/team/JenniferRing.jpeg";

function MeetTheTeamPage() {
  return (
    <Layout title="Meet The Team">
      <SEO title="Meet The Team" />

      <div className="md:hidden text-sm text-blue-600 pb-4">
        <Link to="/">&lt; Back to About</Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 font-medium">
        <div className="border-2 border-black pt-3 px-3 bg-white rounded">
          <img src={goforth} alt="Jonathan Goforth" className="w-40 h-64 object-cover" />
          <div className="pt-2">Jonathan Goforth</div>
        </div>        
        <div className="border-2 border-black pt-3 px-3 bg-white rounded">
          <img src={rebecca} alt="Rebecca Dickerson" className="w-40 h-64 object-cover" />
          <div className="pt-2">Rebecca Dickerson</div>
        </div>
        <div className="border-2 border-black pt-3 px-3 bg-white rounded">
          <img src={marjie} alt="Marjie Bohning" className="w-40 h-64 object-cover" />
          <div className="pt-2">Marjie Bohning</div>
        </div>                
        <div className="border-2 border-black pt-3 px-3 bg-white rounded">
          <img src={donald} alt="Donald Froneberger" className="w-40 h-64 object-cover" />
          <div className="pt-2">Donald Froneberger</div>
        </div>
        <div className="border-2 border-black pt-3 px-3 bg-white rounded">
          <img src={jamie} alt="Jamie Alaniz" className="w-40 h-64 object-cover" />
          <div className="pt-2">Jamie Alaniz</div>
        </div>   
        <div className="border-2 border-black pt-3 px-3 bg-white rounded">
          <img src={natalie} alt="Natalie Pool" className="w-40 h-64 object-cover" />
          <div className="pt-2">Natalie Pool</div>
        </div>   
        <div className="border-2 border-black pt-3 px-3 bg-white rounded">
          <img src={jennifer} alt="Jennifer Ring" className="w-40 h-64 object-cover" />
          <div className="pt-2">Jennifer Ring</div>
        </div>                
      </div>
    </Layout>
  );
}

export default MeetTheTeamPage;
